import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77fca304"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件类型为: xlsx,xls", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("生成个人成本")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("生成公司尽孝金")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件类型为: xlsx,xls", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-10" }, "证件号码：", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("表格颜色")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "colorMean lightBule-row" }, "支付池转薪酬", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("重复导入")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 覆盖导入 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 跳过导入 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("重复导入")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 覆盖导入 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 跳过导入 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("确定")

import { Ref, ref, onBeforeMount, reactive } from 'vue'
import { ElMessage, ElMessageBox  } from 'element-plus'
import tbMix, {orgCfig} from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import eptBtn from '@/components/ExportButton.vue'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
    // 表格数据
    'GET/salaries/salary_imports/page': fetchList,
    // 新增薪酬导入表
    'POST/salaries/salary_imports': salariesSalary_importsApi,
    // 薪酬数据批量导入
    'POST/salaries/salary_imports/import': importBatchSalaryApi,
    // 用户下拉列表
    'GET/users/list': usersListApi,
    // 薪酬项目维护(按种类划分)
    'GET/salary_categories': salary_categoriesApi,
    // 批量导入模板下载
    'GET/salaries/salary_imports/download': batchDownloadApi,
    // 单个导入
    'GET/salaries/import_details/download': singleDownloadApi,
    // 行修改
    'PATCH/salaries/salary_imports': editRowApi,
    // 创建薪酬导入明细
    'GET/salaries/salary_imports/{id}': getsalarDetailsApi,
    // 创建薪酬导入明细
    'POST/salaries/import_details': salariesImport_detailsApi,
    // 删除薪酬导入明细
    'DELETE/salaries/import_details/{id}': delSalariesImportApi,
    // 更新薪酬导入明细
    'PUT/salaries/import_details': updateSalariesImportApi,
    // 薪酬数据导入方式
    'PUT/salaries/import_details/import/confirm': import_detailsImportConfirmApi,
    // 薪酬数据单个导入
    'POST/salaries/import_details/import': salariesImport_detailsImportApi,
    // 薪酬导入表删除
    'DELETE/salaries/salary_imports/{id}': delSalariesSalary_importsIdApi,
    // 批量薪酬数据导入方式
    'PUT/salaries/salary_imports/import/confirm': salariesSalary_importsImportConfirmApi,
    // 获取所有薪酬导入明细
    'GET/salaries/import_details': getSalariesImport_detailsApi,
    // 薪酬导入数据重复校验2.0版本（单个）
    'POST/salaries/import_details/import/check': salariesImport_detailsImportCheckApi,
    // 薪酬导入数据重复校验2.0版本（批量）
    'POST/salaries/salary_imports/import/check': salariesSalary_importsImportCheckApi,
    // 生成个人成本
    'PUT/salaries/salary_imports/create/person_cost': createPerson_costApi,
    // 生成公司尽孝金
    'PUT/salaries/salary_imports/create/company_filial': company_filialApi,
} = Api

let { 
    MI_height, MI_tableData, fetchData, page, size, MI_total, 
    MI_pageChange, MI_sizeChange, MI_identify, MI_modifyForm, MI_params 
} = new tbMix(fetchList)


const searchConfig = ref([
    {
        type: "TIME",
        label: "所属日期",
        value: '',
        upKey: 'date',
        props: { type: 'date', clearable: true }
    },
    {
        type: 'SELECT',
        label: '导入项目',
        value: '',
        upKey: 'categoryId',
        options: [],
        seleProps: { label: 'name', valueName: 'id', },
        props: { placeholder: '请选择项目', clearable: true }
    },
    {
        label: '操作人',
        value: '',
        upKey: 'operator',
    }
])

const serachHandle = (params: any) => {
    fetchData(params, {}, 1)
}

let userOptions = ref([])
onBeforeMount(() => {
    salary_categoriesApi({type: 'ALL'}).then((categoryList: any) => {
        searchConfig.value[1].options = categoryList
    })

    usersListApi().then((rep: any) => {
        userOptions.value = rep.map((_user: any) =>{
        _user.name = _user.alias + '(' + _user.realName+ ')'
        return _user
        })
  })
})

// 导入项目弹窗
const additonFg: Ref<boolean> = ref(false)
const additonConfig = ref<FromConfig[]>([
    {
        label: '导入摘要',
        value: '',
        upKey: 'content',
        props: { placeholder: '请输入摘要'}
    },
    {
        type: "TIME",
        label: "所属日期",
        value: '',
        upKey: 'date',
        rule: [
            { required: true, message: '请选择所属日期', trigger: 'change' },
        ],
        props: {
            type: 'date',
            placeholder: '请选择所属日期'
        },
    },
    {
        type: 'SELECT',
        label: '类别',
        value: '',
        upKey: 'type',
        options: [
            { label: '福利', id: 'WELFARE' },
            { label: '奖金', id: 'BONUS' },
            { label: '工资', id: 'SALARY' },
            { label: '提成', id: 'COMMISSION' },
            { label: '考勤', id: 'ATTENDANCE' },
            { label: '个税', id: 'TAX' },
            { label: '养老保险', id: 'END_INS' },
            { label: '医疗保险', id: 'MED_INS' },
            { label: '失业保险', id: 'UNE_INS' },
            { label: '工伤保险', id: 'EMP_INS' },
            { label: '生育保险', id: 'MAT_INS' },
            { label: '住房公积金', id: 'HPF' },
            { label: '其他扣款', id: 'OD' },
            { label: '其他', id: 'OTHER' },
            { label: '一次性奖励', id: 'OTR' },
            { label: '个人部分', id: 'PERSON' },
        ],
        rule: [{ required: true, message: '请选择类别', trigger: 'change' }],
        seleProps: {label: 'name',valueName: 'id',},
        props: { placeholder: '请选择类别', clearable: false },
        selectCb: (val: string, upkey: string) => {
            salary_categoriesApi({type: val}).then((rep: any) => {
                additonConfig.value[3].value = ''
                additonConfig.value[3].options = rep
                
            })
        }
    },
    {
        type: 'SELECT',
        label: '导入项目',
        value: '',
        upKey: 'categoryId',
        options: [],
        placeholder: '请选择项目',
        rule: [{ required: true, message: '请选择导入项目', trigger: 'change' },],
        selectFunc: salary_categoriesApi,
        seleProps: {label: 'name',valueName: 'id',},
        funcParam: {type: 'ALL'},
        props: { placeholder: '请选择项目' }
    },
    {
        label: '备注',
        value: '',
        upKey: 'remarks',
        props: { placeholder: '请输入备注'}
    },
])
const showAddtion = (row: object, isAddition = true):void => {
    MI_modifyForm(row, additonConfig, additonFg, async (params: any) => {
        await salariesSalary_importsApi(params)
        additonFg.value = false
        fetchData(MI_params)
    })

}

// 生成个人成本
const generateFg: Ref<boolean> = ref(false)
const generateConfig = ref([
    {
        type: "TIME",
        label: "月份",
        value: '',
        upKey: 'month',
        rule: [{ required: true, message: '请选择月份', trigger: 'change' }],
        props: { type: 'month', placeholder: '请选择所属日期' },
    },
    {
        type: 'SELECT',
        label: '类别',
        value: '',
        upKey: 'type',
        options: [
            { label: '个人尽孝金', id: '个人尽孝金' },
            { label: '个人公积金', id: '个人公积金' },
            { label: '个人社保合计', id: '个人社保合计' },
        ],
        rule: [{ required: true, message: '请选择类别', trigger: 'change' },],
        seleProps: {label: 'name',valueName: 'id',},
        props: { placeholder: '请选择类别', clearable: false },
    },
])
const generateCost = () => {
    MI_modifyForm({}, generateConfig, generateFg, async (params: object) => {
        await createPerson_costApi(params, {contentType: 'formData'})
        ElMessage.success('成功')
        generateFg.value = false
        fetchData(MI_params)
    })
}

// 行修改
const editRow = async (row: any) => {
    let _row = await getsalarDetailsApi({id: row.id})
    MI_modifyForm(_row, additonConfig, additonFg, async (params: any) => {
        await editRowApi({...params, id: row.id})
        additonFg.value = false
        fetchData(MI_params)
    })
}
// 行删除
const delSalaryHandle = (row: any) => {
    ElMessageBox.confirm(
        '是否确认删除：' + row.content,
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(() => {
        MI_identify.value = true
        return delSalariesSalary_importsIdApi({id: row.id})
    }).then(() => {
        ElMessage.success('删除成功')
        MI_identify.value = false
        fetchData(MI_params)

    }).catch(() => {
        MI_identify.value = false
    })
}
// 导入人员弹窗
const detailsSearchObj = reactive({
    name: null, cardId: null,
})
/* const dtSearchConfig = ref([
    {
        label: '姓名',
        value: '',
        upKey : 'name',
    },
    {
        label: '证件号码',
        value: '',
        upKey : 'cardId',
    }
]) */
const importFg: Ref<boolean> = ref(false)
const isDetalisLoad: Ref<boolean> = ref<boolean>(false)
let importData: Ref<object[]> = ref([])
let importRow: any = reactive({})
const showImport = (row: object):void => {
    Object.assign(importRow, row)
    // 打开明细弹框
    importFg.value = true
    dtSerachHandle()
}
const dtSerachHandle = (params = {}) => {
    isDetalisLoad.value = true

    return getSalariesImport_detailsApi({importId: importRow.id, name: detailsSearchObj.name || null, cardId: detailsSearchObj.cardId || null}).then((rep: any) => {
        importData.value = rep
    }).finally(() => {
        isDetalisLoad.value = false
    })
}

// 明细增删改查
const addImportFg = ref<boolean>(false)
const addImportConfig: any = ref([
     {
        type: 'SELECT',
        label: '员工',
        value: '',
        upKey: 'userId',
        options: userOptions,
        placeholder: '请选择员工',
        rule: [
            { required: true, message: '必选项', trigger: 'change' },
        ],
        props: { disabled: true },
        seleProps: {
            label: 'name',
            valueName: 'userId',
        }
    },
    orgCfig({
        rule: [{ required: true, message: '必选项', trigger: 'change' }],
    }),
    /* {
        type: 'SELECT',
        label: '团队',
        value: '',
        upKey: 'orgId',
        options: [],
        selectFunc: organizationsApi,
        seleProps: {
            label: 'name',
            valueName: 'id',
        },
        rule: [
            { required: true, message: '必选项', trigger: 'change' },
        ],
        props: { placeholder: '请选择团队', clearable: true }
    }, */
    {
        type: 'NUMBER',
        label: '金额',
        value: '',
        upKey: 'amount',
        rule: [
            { type: 'number', message: '必须是数字' },
            { required: true, message: '必选项', trigger: 'change' },
        ],
        props: {type: 'number'}
    },
    {
        label: '备注',
        value: '',
        upKey: 'remarks',
    }
])
const addImport = () => {
    addImportConfig.value[0].props.disabled = false
    MI_modifyForm({}, addImportConfig, addImportFg, async (params: any) => {
        await salariesImport_detailsApi({...params, importId: importRow.id})
        addImportFg.value = false
        ElMessage.success('添加成功')
        // 添加成功后刷新
        let rep = await getSalariesImport_detailsApi({importId: importRow.id})
        importData.value = rep
    })
}
const delImportHandle = async (row: any) => {
    await ElMessageBox.confirm(
        '该数据删除后将回到支付池中',
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        }
    )
    await delSalariesImportApi({id: row.id})
    ElMessage.success('删除成功')
    let rep = await getSalariesImport_detailsApi({importId: importRow.id})
    importData.value = rep

}

const addEditImportFg = ref<boolean>(false)
const editImportHandle = (row: any) => {
    addImportConfig.value[0].props.disabled = true
    MI_modifyForm(row, addImportConfig, addEditImportFg, async (params: any) => {
        await updateSalariesImportApi({...params, importId: importRow.id, id: row.id})
        addEditImportFg.value = false
        ElMessage.success('编辑成功')
        // 添加成功后刷新
        let rep = await getSalariesImport_detailsApi({importId: importRow.id})
        importData.value = rep
    })
}


// 上传成功后第一次展示的数据
const repeatSelectFg = ref<boolean>(false)
let repetitiveRow = ref([])
let repetitiveInfoUser: any = ref([])
let submitRepetitiveHandle: any = ref();
// 第二次展示的表格
const repeatFg = ref<boolean>(false)
const repeatTbData = ref([])

const upSuccessHandle = (rep: any, row: any) => {
    
    // 上传成功后先展示选择表格
    repetitiveInfoUser.value = Object.keys(rep).map((key: string, index) => {
        return {
            userName: key,
            cardId: index,
            children: rep[key]
        }
    })
    
    return new Promise((resolve) => {
        submitRepetitiveHandle.value = resolve
        repeatSelectFg.value = true
    }).then(() => {
        // 第一次重复弹框处理
        return salariesImport_detailsImportCheckApi({
            importId: row.id,
            infoList: repetitiveRow.value
        })
    })
    .then((rep) => {
        ElMessage.success('成功')
        repeatSelectFg.value = false
        // 第二次重复弹框处理
        repeatTbData.value = rep
        repeatFg.value = true
    }).catch(() => {
        repeatSelectFg.value = false
    })
}



const submitRepeat = async (str: string) => {
    await import_detailsImportConfirmApi({option: str}, {'contentType': "formData"})
    ElMessage.success('成功')
    repeatFg.value = false
}
// 批量上传成功后续处理
const repeatAllFg = ref<boolean>(false)
const repeatAllTbData = ref([])
const upAllSuccessHandle = (rep: any) => {
    // repeatAllTbData.value = rep
    // repeatAllFg.value = true

    // 上传成功后先展示选择表格
    repetitiveInfoUser.value = Object.keys(rep).map((key: string, index) => {
        return {
            userName: key,
            cardId: index,
            children: rep[key]
        }
    })

    return new Promise((resolve) => {
        submitRepetitiveHandle.value = resolve
        repeatSelectFg.value = true
    }).then(() => {
        // 第一次重复弹框处理
        return salariesSalary_importsImportCheckApi({
            importId: 0,
            infoList: repetitiveRow.value
        })
    })
    .then((rep) => {
        ElMessage.success('成功')
        repeatSelectFg.value = false
        // 第二次重复弹框处理
        repeatAllTbData.value = rep
        repeatAllFg.value = true
    }).catch(() => {
        repeatSelectFg.value = false
    })
    
}
const submitAllRepeat = async (str: string) => {
    await salariesSalary_importsImportConfirmApi({option: str}, {'contentType': "formData"})
    ElMessage.success('成功')
    repeatAllFg.value = false
}
const tableRowClassName=({ row, rowIndex }: any)=>{
    if(row.billId&&row.billId!=null){
        return 'lightBule-row'
    }
    return ''
}

// 生成公司尽孝金
const isShowCompanyFin = ref<boolean>(false)
const genCompanyMonth = ref<string>('')
const submitCompHandle = () => {
  if(!genCompanyMonth.value){
    ElMessage.warning('请选择月份')
    return
  }
  company_filialApi({month: genCompanyMonth.value}, {contentType: 'formData'}).then(() => {
    ElMessage.success('成功')
    fetchData(MI_params)
    isShowCompanyFin.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "薪酬数据导入-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
                        initSearch: true,
                        title: true,
                        searchConfig: searchConfig.value
                    }, { onSearchFn: serachHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddtion({}))),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
      upText: '批量导入',
      upFetch: _unref(importBatchSalaryApi),
      class: "ml-10",
      upParams: {},
      showBtn: true,
      accept: '.xls, .xlsx',
      onUpSuccess: upAllSuccessHandle
    }, {
      tip: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(eptBtn, {
          exportFn: _unref(batchDownloadApi),
          exportText: '下载批量导入模板',
          isDirect: true
        }, null, 8, ["exportFn"])
      ]),
      _: 1
    }, 8, ["upFetch", "accept"])), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (generateCost())),
      class: "ml-10"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowCompanyFin.value = true))
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(MI_tableData),
      border: "",
      class: "mt-10",
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          width: "80",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "导入摘要",
          prop: "content",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "导入日期",
          width: "180"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(row.createdAt).format('YYYY-MM-DD')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "所属日期",
          prop: "date",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "导入项目",
          prop: "categoryName",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          label: "总金额",
          prop: "amount",
          width: "110",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remarks",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作人",
          prop: "operator",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "350"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  onClick: ($event: any) => (showImport(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (row.canUpdate !== false)
                  ? _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
                      key: 0,
                      upFetch: _unref(salariesImport_detailsImportApi),
                      upParams: {importId: row.id},
                      accept: '.xls, .xlsx',
                      onUpSuccess: ($event: any) => (upSuccessHandle($event, row))
                    }, {
                      tip: _withCtx(() => [
                        _hoisted_6
                      ]),
                      default: _withCtx(() => [
                        _createVNode(eptBtn, {
                          exportFn: _unref(singleDownloadApi),
                          exportText: '下载导入模板(单个)',
                          isDirect: true
                        }, null, 8, ["exportFn", "exportText"])
                      ]),
                      _: 2
                    }, 1032, ["upFetch", "upParams", "accept", "onUpSuccess"])), [
                      [_directive_permission, 'Write']
                    ])
                  : _createCommentVNode("", true),
                (row.canUpdate !== false)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      onClick: ($event: any) => (editRow(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Write']
                    ])
                  : _createCommentVNode("", true),
                (row.canUpdate !== false)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      key: 2,
                      type: "danger",
                      onClick: ($event: any) => (delSalaryHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Delete']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      disabled: _unref(MI_identify),
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : size = $event)),
      class: "mt-10",
      "page-sizes": [30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "薪酬数据导入",
      modelValue: additonFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((additonFg).value = $event))
    }, {
      default: _withCtx(() => [
        (additonFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: additonConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "生成个人成本",
      modelValue: generateFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((generateFg).value = $event))
    }, {
      default: _withCtx(() => [
        (generateFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: generateConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "明细",
      width: "1100px",
      top: "125px",
      modelValue: importFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((importFg).value = $event)),
      onClose: _cache[10] || (_cache[10] = ($event: any) => {_isRef(importData) //@ts-ignore
 ? importData.value = [] : importData = [];_unref(detailsSearchObj).name = '';_unref(detailsSearchObj).cardId = ''; _unref(fetchData)(_unref(MI_params))})
    }, {
      default: _withCtx(() => [
        _hoisted_9,
        _createVNode(_component_el_input, {
          modelValue: _unref(detailsSearchObj).name,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(detailsSearchObj).name) = $event)),
          placeholder: "请输入姓名",
          maxlength: "100",
          clearable: "",
          class: "form-input"
        }, null, 8, ["modelValue"]),
        _hoisted_10,
        _createVNode(_component_el_input, {
          modelValue: _unref(detailsSearchObj).cardId,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(detailsSearchObj).cardId) = $event)),
          placeholder: "请输入证件号码",
          maxlength: "100",
          clearable: "",
          class: "form-input"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dtSerachHandle,
          class: "ml-10"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        (_unref(importRow).canUpdate !== false)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: addImport,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })), [
              [_directive_permission, 'Create']
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 400,
          trigger: "hover"
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_el_button, { type: "info" }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_divider, null, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _hoisted_15
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "mt-10",
          "row-class-name": tableRowClassName,
          data: _unref(importData),
          border: "",
          "max-height": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "userName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "证件号码",
              prop: "cardId",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "备注",
              prop: "remarks",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                (_unref(importRow).canUpdate !== false)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "danger",
                      onClick: ($event: any) => (delImportHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Delete']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isDetalisLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "创建明细",
      modelValue: addImportFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addImportFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addImportFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                searchConfig: addImportConfig.value,
                submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑明细",
      modelValue: addEditImportFg.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addEditImportFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addEditImportFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                searchConfig: addImportConfig.value,
                submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: repeatSelectFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((repeatSelectFg).value = $event)),
      width: "50%",
      title: "重复展示选择"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(submitRepetitiveHandle)()))
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  "row-key": "cardId",
                  border: "",
                  "max-height": "500px",
                  onSelectionChange: _cache[13] || (_cache[13] = (row) => _isRef(repetitiveRow) //@ts-ignore
 ? repetitiveRow.value = row : repetitiveRow = row),
                  data: _unref(repetitiveInfoUser)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "55"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "重复员工选择",
                      prop: "userName",
                      width: "230",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(({row}) => [
                        _createVNode(_component_el_link, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.userName), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "姓名",
                      prop: "label",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "证件号码",
                      prop: "cardId",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "金额",
                      prop: "amount",
                      align: "right",
                      formatter: _unref(formatNumber),
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: repeatFg.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((repeatFg).value = $event)),
      title: "重复展示"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (submitRepeat('repeat'))),
          type: "warning"
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (submitRepeat('cover')))
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createVNode(_component_el_popover, {
              placement: "top-start",
              trigger: "hover",
              effect: "dark",
              width: 220,
              content: "将会删除该人同项目所有数据"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (submitRepeat('skip'))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _createVNode(_component_el_popover, {
              placement: "top-start",
              trigger: "hover",
              effect: "dark",
              width: 210,
              content: "本次导入将跳过以上数据"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: repeatTbData.value,
          "max-height": "600px",
          class: "mb-10",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "name"
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName"
            }),
            _createVNode(_component_el_table_column, {
              label: "项目",
              prop: "categoryName"
            }),
            _createVNode(_component_el_table_column, {
              label: "金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: repeatAllFg.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((repeatAllFg).value = $event)),
      title: "批量上传重复展示"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (submitAllRepeat('repeat'))),
          type: "warning"
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[21] || (_cache[21] = ($event: any) => (submitAllRepeat('cover')))
        }, {
          default: _withCtx(() => [
            _hoisted_22,
            _createVNode(_component_el_popover, {
              placement: "top-start",
              trigger: "hover",
              effect: "dark",
              width: 220,
              content: "将会删除该人同项目所有数据"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[22] || (_cache[22] = ($event: any) => (submitAllRepeat('skip'))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_23,
            _createVNode(_component_el_popover, {
              placement: "top-start",
              trigger: "hover",
              effect: "dark",
              width: 210,
              content: "本次导入将跳过以上数据"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: repeatAllTbData.value,
          "max-height": "600px",
          class: "mb-10",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "name"
            }),
            _createVNode(_component_el_table_column, {
              label: "团队",
              prop: "orgName"
            }),
            _createVNode(_component_el_table_column, {
              label: "项目",
              prop: "categoryName"
            }),
            _createVNode(_component_el_table_column, {
              label: "金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "生成公司尽孝金",
      modelValue: isShowCompanyFin.value,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((isShowCompanyFin).value = $event)),
      width: "500",
      onClose: _cache[28] || (_cache[28] = ($event: any) => (genCompanyMonth.value = ''))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[25] || (_cache[25] = ($event: any) => (isShowCompanyFin.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (submitCompHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: genCompanyMonth.value,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((genCompanyMonth).value = $event)),
          type: "month",
          placeholder: "请选择月份",
          "value-format": "YYYY-MM-DD"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})